import { createSelector } from 'reselect';

export const getCurrentGeneralContractor = createSelector(
  (state) => state.generalContractors.data.currentGeneralContractor,
  (currentGeneralContractor) => {
    return currentGeneralContractor;
  }
);

export const getGeneralContractors = createSelector(
  (state) => state.generalContractors.data.generalContractors,
  (generalContractors) => {
    return generalContractors;
  }
);

export const getCurrentPage = createSelector(
  (state) => state.generalContractors.ui.currentPage,
  (currentPage) => {
    return currentPage;
  }
);

export const getLicenceNumber = createSelector(
  (state) => state.generalContractors.ui.licenceNumber,
  (licenceNumber) => {
    return licenceNumber;
  }
);

export const getCurrentStage = createSelector(
  (state) => state.generalContractors.ui.currentStage,
  (currentStage) => {
    return currentStage;
  }
);

export const getCompanyLogo = createSelector(
  (state) => state.generalContractors.ui.companyLogo,
  (companyLogo) => {
    return companyLogo;
  }
);

export const getProjects = createSelector(
  (state) => state.generalContractors.data.projects,
  (projects) => {
    return projects;
  }
);

export const getProjectsCurrentPage = createSelector(
  (state) => state.generalContractors.ui.projectsCurrentPage,
  (projectsCurrentPage) => {
    return projectsCurrentPage;
  }
);

export const getUsers = createSelector(
  (state) => state.generalContractors.data.users,
  (users) => {
    return users;
  }
);

export const getShowContactsModal = createSelector(
  (state) => state.generalContractors.ui.showContacts,
  (showContacts) => {
    return showContacts;
  }
);



// WEBPACK FOOTER //
// ./src/components/admin/general-contractors/store/selectors.js